export default "__VITE_ASSET__2989caad__"